import { createFileRoute } from "@tanstack/react-router";

import LeagueCompetitorSidebar from "@/components/LeagueEntries/LeagueCompetitorSidebar";

const Component = () => {
  const { leagueUuid, userUuid } = Route.useParams();
  return <LeagueCompetitorSidebar leagueUuid={leagueUuid} userUuid={userUuid} />;
};

export const Route = createFileRoute(
  "/gym/$venueUuid/events/series/$leagueUuid/competitors/$userUuid",
)({
  component: Component,
});
